export const getNumber = (value: unknown) =>
  typeof value === 'number' && Number.isFinite(value) ? value : undefined;
